import { LoginComponentProps, LoginComponentHandler, LoginComponentState } from './logincomponent';
import { LoginCSSStyle } from './logincss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { ButtonComponent } from '../../../toolkit/button/buttoncomponent';
//import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

//import { LoginDto, LoginDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/login/logindto';
import { MsisdnFloatingTextComponent } from '../../../toolkit/floatingtext/msisdnfloatingtext/msisdnfloatingtextcomponent';
import { Strings } from '../../../../utils/resources/strings';
import { LoginDto, LoginDtoImpl } from '../../../../core/dto/login/logindto';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { MSISDNValidation } from '../../../toolkit/msisdnvalidation/msisdnvalidation';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { ConfirmRequestConfirmButtonCSSStyleImpl } from '../../popup/confirmrequest/confirmrequestconfirmbuttoncss';
import './login-style.css';
import { CreateAccountDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/createaccount/createaccountdto';
import { LoginOTPVerificationComponent } from './loginotpverification/loginotpverificationcomponent';

export class LoginViewImpl extends UIComponentViewImpl<UIDataModel>
{
    private popupComponent:PopUpWrapperComponent;
    private loaderWrapperComponent:LoaderWrapperComponent;
    private numberComponent: any;

    
    bindHandlers()
    {
        this.onLoginButtonClick = this.onLoginButtonClick.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
        // this.hideCategoriesPopUp = this.hideCategoriesPopUp.bind(this);
        this.doLogin = this.doLogin.bind(this);
        this.onKeyPressEvent = this.onKeyPressEvent.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.validateLoginDetails = this.validateLoginDetails.bind(this);
        // document.addEventListener("keydown",this.onKeyPressEvent);

    }

    draw(props: LoginComponentProps, state: UIComponentState, cssStyle: LoginCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
     

        return (
            
            <div id="login-wrapper" style={cssStyle.getWrapperCSSStyle()}>
           
                <div id="login-inner-wrapper"  style={cssStyle.getInnerWrapperCSSStyle()}>
         
                    <img id="login-page-logo" onClick={this.onLogoClicked} style={{cursor: "pointer",marginTop:'0px'}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
           
                    <label id="login-page-heading" style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.logintouraccount)}</label>
                    
                    <label id="login-page-subtitle" style={cssStyle.getSubtitleCSSStyle()}>
                            {props.context.getResources().getString(Strings.login_sub_title)}
                    </label> 
                    <div style={cssStyle.getMobileNumberCSSStyle()}>
                         
                        <MsisdnFloatingTextComponent hint={this.getContext().getResources().getString(Strings.mobilenumberhint)} maxLength={this.getUIProps().context.getResources().getString(Strings.numberMaxLength)} ref={(item: any) => this.numberComponent = item} id={"#mobileNumber"} value={props.context.getUserContext().getMsisdn()} inputType={"number"} isRequired={true} placeholder={props.context.getResources().getString(Strings.mobilenumber)} context={props.context} emptyErrorMsg={props.context.getResources().getString(Strings.numberIncorrect)}/>
                    </div>
                  
                   
                    <div  style={cssStyle.getLoginButtonCSSStyle()}>
                        <ButtonComponent   onClick={this.validateLoginDetails}  style={new ConfirmRequestConfirmButtonCSSStyleImpl(props.context)} context={props.context} label={props.context.getResources().getString(Strings.login)}/>
                    </div>
                    <div style={{width:"100%",height:"38px",marginTop:"120px",display:"flex",textAlign:"left",fontSize:"14px",fontFamily:props.context.getResources().getFontFamily()}}>
                         <p id="login-page-paragraph">
                             {"By Signing up you will be agree to our "}
                             <a href={this.getContext().getProperty().getTermOfUseLink()} target="_blank" id="login-page-link">
                                 {"Terms of use "}
                             </a>
                             {"& "}
                             <a href={this.getContext().getProperty().getPrivacyPolicyLink()} target="_blank" id="login-page-link">
                                 {"Privacy Policy."}
                             </a>
                         </p>
                    </div>
                    <br/>
                   
                </div>
                
                <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
              
                <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>

            </div>
        );
    }
    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onLogoClicked();
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.hidePopup} onClick={this.hidePopup} context={this.getUIProps().context}/>);
    }

    showOTPPopUp()
    {
        let state = (this.getUIState() as LoginComponentState);
        
        this.popupComponent !== null && this.popupComponent.setShowWindow(true,
            <LoginOTPVerificationComponent msisdn={this.getUIProps().context.getUserContext().getMsisdn()} secToken={state.sectoken} isNewUser={state.isNewUser} onOTPSuccess={() => {this.onOTPSuccess();}} id={this.getUIProps().context.getResources().getString(Strings.otp_verification)} showPopup={this.showPopup} closePopup={this.hidePopup} context={this.getUIProps().context}/>);
    }

    // showCategoriesPopUp()
    // {
    //     this.popupComponent !== null && this.popupComponent.setShowWindow(true,
    //         <LoginCategoriesComponent hideCategoriesPopup={this.hideCategoriesPopUp} seletedCategories={[]} isEditable={true} listOfDatas={(this.getUIState() as LoginComponentState).listOfCategories} context={this.getUIProps().context}/>);
    // }

    onOTPSuccess()
    {
        // if(!(this.getUIState() as LoginComponentState).isNewUser)
        // {
        //     this.doLogin();
        // }
        // else
        // {
        //     this.showCategoriesPopUp();
        // }
        this.doLogin();
    }

    getCreateAccountData()
    {
        let request = new CreateAccountDtoImpl();
        request.setMsisdn(this.numberComponent.getData());
        request.setEmail("");
        request.setLanguage(this.getUIProps().context.getUserContext().getLanguage());
        request.setPassword("Oem@L#@1");
        request.setCategoryId((this.getUIState() as LoginComponentState).listOfCategories[0].getId());
        // (this.getUIComponentHandler() as LoginComponentHandler).createAccount(request);

        return request;
        // this.hidePopup();
    }

    hidePopup()
    { 
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    
   
    getUIComponentHandler(): LoginComponentHandler
    {
        return super.getUIComponentHandler() as LoginComponentHandler;
    }

    // onRequestOtpClick():void{
    //     this.popupComponent !== null && this.popupComponent.setShowWindow(true,
    //         <LoginCategoriesComponent closePopup={() =>{}} showPopup={() => {}} showPopupOption={() =>{}} seletedCategories={[]} isEditable={true} ref={(item: any) => this.categoryListComponent = item} listOfDatas={this.getCategoriesData()} context={this.getContext()}/>);
    //     }

    validateLoginDetails(): void
    {
        if(this.numberComponent.validate())
        {
            let msisdn = MSISDNValidation.validateCCMsisdn(
                this.getUIProps().context.getResources().getString(Strings.countrycode), this.numberComponent.getData());

            let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
            let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);

            if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
            {
                this.numberComponent.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
            }
        
            else
            {
                this.numberComponent.setErrorMessage(undefined);

                this.onLoginButtonClick();
            }
        }     
       
    }

    getData(): LoginDto
    {
        let request = new LoginDtoImpl();
        request.setMsisdn(this.numberComponent.getData());
        request.setPassword("Oem@L#@1");
       
        return request;
    }

    onKeyPressEvent(event:any):void
    {
       
        if (event.key === "Enter") 
        {  
            console.log("Enter key pressed!");
            this.validateLoginDetails();
            
            
        }
        
    }

    private onLoginButtonClick()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).onLoginButtonClick();
    }

    private doLogin()
    {
        (this.getUIComponentHandler() as LoginComponentHandler).doLogin();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/login/loginview.tsx